import { useEffect, useState, useRef } from "react";
import styles from "../../styles/chatStyles";
import ChatHeader from "./ChatHeader";

import MessageBubble from "./MessageBubble";
import MessageInput from "./MessageInput";
import { useNotifications } from "../../context/NotificationContext";


import { db } from "../../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  setDoc,
  doc,
  getDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  arrayRemove
} from "firebase/firestore";

import { uploadToCloudinary } from "../../utils/cloudinary";

export default function ChatArea({ chat, pendingJump, clearJump }) {
  const typingTimeout = useRef(null);
  const [dicePos, setDicePos] = useState({
  x: 0,
  y: 0,
  scale: 1.4,
});
const [diceParticles, setDiceParticles] = useState([]);
const [diceFlash, setDiceFlash] = useState(false);
const isFirstLoad = useRef(true);
const bottomRef = useRef(null);
const [shake, setShake] = useState(false);
const { pushNotification } = useNotifications();
const currentUser = JSON.parse(localStorage.getItem("userData"));
const lastNotifiedId = useRef(null);

  const user = localStorage.getItem("user");

  // 🔥 ВАЖНО: chatId должен быть ДО функций
  const chatId = chat?.id || null;

  window.currentChatId = chatId;

  useEffect(() => {
  if (!chatId || !user) return;

  const timer = setTimeout(() => {
    setDoc(doc(db, "chats", chatId), {
  unread: {
    [user]: 0
  }
}, { merge: true });
  }, 300); // 💥 даём Firestore обновиться

  return () => clearTimeout(timer);

}, [chatId]);

  const [highlightId, setHighlightId] = useState(null);

  useEffect(() => {
  window.highlightMessage = (id) => {
    const el = document.getElementById(`msg-${id}`);

    if (!el) return;

    // 🔥 скролл к сообщению
    el.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    // 🔥 подсветка
    setHighlightId(id);

    setTimeout(() => {
      setHighlightId(null);
    }, 1500);
  };

  return () => {
    window.highlightMessage = null;
  };
}, []);

  const [selectedMessages, setSelectedMessages] = useState([]);
  const isSelectionMode = selectedMessages.length > 0;

  const [typing, setTyping] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [reply, setReply] = useState(null);
  const [hoveredBtn, setHoveredBtn] = useState(null);
  const [rollingDice, setRollingDice] = useState(null);
  const [animateOnLoad, setAnimateOnLoad] = useState(false);

  const prevCount = useRef(0);

  const [usersMap, setUsersMap] = useState({});


  // ✅ фикс: функция выбора сообщений (у тебя её не было)
  const toggleSelect = (id) => {
    setSelectedMessages((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  // ⭐ избранное
  const toggleFavorite = async (msg) => {
    if (!chatId) return;

    const ref = doc(db, "chats", chatId, "messages", msg.id);

    const isFav = msg.favoriteBy?.includes(user);

    await updateDoc(ref, {
      favoriteBy: isFav
        ? arrayRemove(user)
        : arrayUnion(user),
    });
  };

  console.log("chatId:", chatId);
console.log("jump:", sessionStorage.getItem("jumpToMessage"));

const spawnParticles = (type) => {
  const count = 18;

  const particles = Array.from({ length: count }).map((_, i) => ({
    id: i,
    angle: Math.random() * Math.PI * 2,
    distance: 40 + Math.random() * 40,
    size: 2 + Math.random() * 3,
    duration: 400 + Math.random() * 300,
    type,
  }));

  setDiceParticles(particles);

  setTimeout(() => {
    setDiceParticles([]);
  }, 700);
};

const justJumped = useRef(false);

useEffect(() => {
  if (!pendingJump) return;
  if (!messages.length) return;

  justJumped.current = true; // 💥 БЛОКИРУЕМ АВТОСКРОЛЛ

  const tryScroll = () => {
    const el = document.getElementById(`msg-${pendingJump.msg}`);

    if (!el) {
      requestAnimationFrame(tryScroll);
      return;
    }

    el.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    setHighlightId(pendingJump.msg);

    setTimeout(() => {
      setHighlightId(null);

      // 💥 через время разрешаем автоскролл обратно
      setTimeout(() => {
        justJumped.current = false;
      }, 500);

      clearJump?.();
    }, 1500);
  };

  tryScroll();

}, [pendingJump, messages]);

useEffect(() => {
  isFirstLoad.current = true;

  // 💥 включаем анимацию при смене чата
  setAnimateOnLoad(true);

  // выключаем через время
  const t = setTimeout(() => {
    setAnimateOnLoad(false);
  }, 600);

  return () => clearTimeout(t);
}, [chatId]);

useEffect(() => {
  const unsub = onSnapshot(collection(db, "users"), (snap) => {
    const map = {};

    snap.forEach(doc => {
      map[doc.id] = doc.data();
    });

    setUsersMap(map);
  });

  return () => unsub();
}, []);

const getDateLabel = (ts) => {
  const date = getTime(ts);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const isToday =
    date.toDateString() === today.toDateString();

  const isYesterday =
    date.toDateString() === yesterday.toDateString();

  if (isToday) return "Сегодня";
  if (isYesterday) return "Вчера";

  return date.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
  });
};

useEffect(() => {
  prevCount.current = messages.length;
}, [messages]);

const getTime = (ts) => {
  if (!ts) return "";

  if (ts.seconds) {
    return new Date(ts.seconds * 1000);
  }

  return new Date(ts);
};

const renderBigDice = (d, value, isCrit) => {
  const common = {
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
  };

  const centerText = (
  <text
    x="12"
    y="14"
    textAnchor="middle"
    fontSize="7"
    fill="white"
    fontWeight="600"
    stroke="black"
    strokeWidth="0.6"
    paintOrder="stroke"
    style={{
      letterSpacing: "0.3px",
      filter: isCrit
        ? "drop-shadow(0 0 4px #fff) drop-shadow(0 0 8px #ffd700)"
        : "none",
    }}
  >
    {value}
  </text>
);

  switch (d) {
    case 6:
      return (
        <svg {...common}>
          <rect x="3" y="3" width="18" height="18" rx="5" />
          {centerText}
        </svg>
      );

    case 20:
  return (
    <svg
      {...common}
      style={{
        filter:
          value === 20
            ? "drop-shadow(0 0 8px rgba(255,255,255,0.9)) drop-shadow(0 0 18px rgba(255,255,255,0.6))"
            : "none",
        transition: "0.2s",
      }}
    >
      <polygon points="12,2 20,6 22,14 16,22 8,22 2,14 4,6" />
      {centerText}
    </svg>
  );

    case 4:
      return (
        <svg {...common}>
          <polygon points="12,3 21,18 3,18" />
          {centerText}
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" />
          {centerText}
        </svg>
      );
  }
};

const hasJumped = useRef(false);

useEffect(() => {
  if (!messages.length) return;

  // ❌ если сейчас делаем jump — НЕ ТРОГАЕМ скролл
  if (pendingJump || justJumped.current) return;

  const container = bottomRef.current?.parentElement;
  if (!container) return;

  const isNearBottom =
    container.scrollHeight - container.scrollTop - container.clientHeight < 100;

  if (isFirstLoad.current || isNearBottom) {
    bottomRef.current?.scrollIntoView({
      behavior: isFirstLoad.current ? "auto" : "smooth",
    });
  }

  isFirstLoad.current = false;

}, [messages, pendingJump]);

const deleteSelected = async () => {
  const own = messages.filter(
    (m) =>
      selectedMessages.includes(m.id) &&
      m.sender === user
  );

  for (let m of own) {
    await deleteDoc(
      doc(db, "chats", chatId, "messages", m.id)
    );
  }

  setSelectedMessages([]);

  // 💥 после удаления — обновляем lastMessage
const remaining = messages
  .filter(m => !selectedMessages.includes(m.id))
  .sort((a, b) => a.createdAt - b.createdAt);

const last = remaining[remaining.length - 1];

await setDoc(doc(db, "chats", chatId), {
  lastMessage: last
    ? last.text || (last.image ? "📷 Фото" : "🎲 бросок")
    : "",
  lastMessageSender: last?.sender || null,
  updatedAt: Date.now(),
}, { merge: true });
};


  // 📩 Загрузка сообщений (🔥 ФИКС)
useEffect(() => {
  if (!chatId) return;

  const q = query(
    collection(db, "chats", chatId, "messages"),
    orderBy("createdAt", "asc")
  );

  const unsub = onSnapshot(q, async (snapshot) => {
    const msgs = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setMessages(msgs);

    const lastMsg = msgs[msgs.length - 1];

    if (
      lastMsg &&
      lastMsg.id !== lastNotifiedId.current &&
      lastMsg.sender !== user &&
      window.currentChatId !== chatId
    ) {
      lastNotifiedId.current = lastMsg.id;

      const userSnap = await getDoc(doc(db, "users", lastMsg.sender));
      const userData = userSnap.exists() ? userSnap.data() : null;

      pushNotification({
        chatId,
        senderName: userData?.name || lastMsg.sender || "Кто-то",
        avatar: userData?.avatar || "/default-avatar.png",
        title: "Новое сообщение",
        text:
          lastMsg.text ||
          (lastMsg.image ? "📷 Фото" : "🎲 Бросок"),
      });
    }
  });

  return () => unsub(); // ✅ ВОТ ЗДЕСЬ ДОЛЖНО БЫТЬ

}, [chatId]);

const actuallySendDice = async (diceData) => {
  await addDoc(collection(db, "chats", chatId, "messages"), {
  ...diceData,
  sender: user,
  senderName: currentUser?.name || user,
  senderAvatar: currentUser?.avatar || "/default-avatar.png",
  createdAt: Date.now(),
  favoriteBy: [],
});

  // 🔥 обновляем чат (как у обычных сообщений)
  await setDoc(doc(db, "chats", chatId), {
  lastMessage: `🎲 бросил d${diceData.dice}`,
  lastMessageSender: user,
  lastMessageSenderName: currentUser?.name || user,
  lastMessageSenderAvatar: currentUser?.avatar || "/default-avatar.png",
  updatedAt: Date.now(),
}, { merge: true });
  
};

const sendMessage = async (textFromInput) => {
    if (textFromInput?.type === "dice") {
  setRollingDice(textFromInput);

// старт — центр
setDicePos({
  x: 0,
  y: 0,
  scale: 1.4,
});

// через время "падаем вниз"
setTimeout(() => {
  // падение
  setDicePos({
    x: 0,
    y: 220,
    scale: 0.6,
  });

  // отскок
  setTimeout(() => {
    setDicePos({
      x: 0,
      y: 180,
      scale: 0.65,
    });
  }, 120);

  // финал
  setTimeout(() => {
    setDicePos({
      x: 0,
      y: 200,
      scale: 0.6,
    });
  }, 220);

}, 300);

if (textFromInput.dice === 20) {
  if (textFromInput.value === 20) {
    setDiceFlash(true);
    spawnParticles("crit");
  }

  if (textFromInput.value === 1) {
    spawnParticles("fail");
  }

  setTimeout(() => {
    setDiceFlash(false);
  }, 400);
}

// 💥 тряска при ударе
setTimeout(() => {
  setShake(true);

  setTimeout(() => setShake(false), 400);
}, 500);

setTimeout(() => {
  setRollingDice(null);
  actuallySendDice(textFromInput);
}, 800);

  return;
}
  if (!chatId) return;

if (typeof textFromInput === "string" && !textFromInput.trim()) return;

  const chatRef = doc(db, "chats", chatId);

  const msg =
  typeof textFromInput === "string"
    ? {
        text: textFromInput,
        sender: user,
        senderName: currentUser?.name || user,
        senderAvatar: currentUser?.avatar || "/default-avatar.png",
        createdAt: Date.now(),
        replyTo: reply || null,
        favoriteBy: [],
      }
    : {
        ...textFromInput, // 💥 сюда прилетает dice
        sender: user,
        createdAt: Date.now(),
        replyTo: reply || null,
        favoriteBy: [],
      };

  await addDoc(collection(db, "chats", chatId, "messages"), msg);

  const chatSnap = await getDoc(chatRef);
  if (!chatSnap.exists()) return;

  const chatData = chatSnap.data();

  const members =
    chat?.members ||
    [chat?.user?.username, user].filter(Boolean);

  let unreadUpdate = {};

  members.forEach((u) => {
    if (u !== user) {
      unreadUpdate[u] =
  (chatData.unread?.[u] || 0) + 1;
    }
  });

  await setDoc(chatRef, {
  lastMessage:
    typeof textFromInput === "string"
      ? textFromInput
      : `🎲 бросил d${textFromInput.dice}`,
  lastMessageSender: user,
    lastMessageSenderName: currentUser?.name || user,     // 💥
  lastMessageSenderAvatar: currentUser?.avatar || null, // 💥
  updatedAt: Date.now(),
  typing: null,

  unread: {
    ...(chatData.unread || {}),
    ...unreadUpdate
  }

}, { merge: true });

  setReply(null);



};


  // 👀 typing listener
  useEffect(() => {
    if (!chatId) return;

    const unsub = onSnapshot(doc(db, "chats", chatId), (snap) => {
      if (snap.exists()) {
        setTyping(snap.data().typing || null);
      }
    });

    return () => unsub();
  }, [chatId]);

  useEffect(() => {
  setSelectedMessages([]);
}, [chatId]);

  // 🖼️ отправка картинки
  const sendImage = async (file) => {
    await setDoc(doc(db, "chats", chatId), {
  lastMessage: "📷 Фото",
  lastMessageSender: user,
  lastMessageSenderName: currentUser?.name || user,
  lastMessageSenderAvatar: currentUser?.avatar || "/default-avatar.png",
  updatedAt: Date.now(),
}, { merge: true });

    if (!file || !chatId) return;

    const url = await uploadToCloudinary(file);

    await addDoc(collection(db, "chats", chatId, "messages"), {
  image: url,
  sender: user,
  senderName: currentUser?.name || user,
  senderAvatar: currentUser?.avatar || "/default-avatar.png",
  createdAt: Date.now(),
});

    await setDoc(doc(db, "chats", chatId), {
  typing: null
}, { merge: true });
    
  };
  

  if (!chat) {
  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "30px 25px",
          borderRadius: "20px",

          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",
          backdropFilter: "blur(12px)",

          maxWidth: "220px",
        }}
      >
        {/* иконка */}
        <div
            style={{
                width: 36,
                height: 36,
                margin: "0 auto 12px",
                opacity: 0.7,
            }}
            >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ width: "100%", height: "100%" }}
            >
                <path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
            </svg>
            </div>

        {/* текст */}
        <div
          style={{
            fontSize: "14px",
            opacity: 0.7,
            lineHeight: 1.4,
          }}
        >
          Выбери чат,
          <br />
          чтобы начать общение
        </div>
      </div>
    </div>
  );
}



 return (

    
  <div
  style={{
    ...styles.chatArea,
    animation: shake ? "shake 0.4s ease" : "none",
  }}
>

    {selectedMessages.length > 0 && (
  <div style={styles.toolbar}>
  
  {/* shimmer слой */}
  <div style={styles.toolbarShimmer} />

  {/* контент */}
  <div style={styles.toolbarContent}>
      
      <div style={styles.toolbarCount}>
        {selectedMessages.length}
      </div>

        <div
  style={styles.tooltipWrap}
  onMouseEnter={() => setHoveredBtn("reply")}
  onMouseLeave={() => setHoveredBtn(null)}
>
      <button
        style={styles.toolbarBtn}
        onClick={() => {
          // ответ на первое выбранное
          const first = messages.find(m =>
            m.id === selectedMessages[0]
          );

          if (!first) return;

            setReply({
            id: first.id, // 💥 тоже добавляем
            text: first.text || "📷 Фото",
            sender: first.sender
            });

          setSelectedMessages([]);
        }}
      >
        ↩
      </button>

  <div
    style={{
      ...styles.tooltip,
      opacity: hoveredBtn === "reply" ? 1 : 0,
      transform:
        hoveredBtn === "reply"
            ? "translateX(-50%) translateY(4px)"
            : "translateX(-50%) translateY(0px)"
    }}
  >
    Ответить
  </div>
</div>

<div
  style={styles.tooltipWrap}
  onMouseEnter={() => setHoveredBtn("delete")}
  onMouseLeave={() => setHoveredBtn(null)}
>
      <button style={styles.toolbarBtn} onClick={deleteSelected}>
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M3 6h18" />
            <path d="M8 6V4h8v2" />
            <path d="M6 6l1 14h10l1-14" />
            <path d="M10 11v6" />
            <path d="M14 11v6" />
        </svg>
        </button>
        <div
                style={{
                ...styles.tooltip,
                opacity: hoveredBtn === "delete" ? 1 : 0,
                transform:
                hoveredBtn === "delete"
                    ? "translateX(-50%) translateY(4px)"
                    : "translateX(-50%) translateY(0px)"
                }}
            >
                Удалить
            </div>
            </div>

            <div
                style={styles.tooltipWrap}
                onMouseEnter={() => setHoveredBtn("fav")}
                onMouseLeave={() => setHoveredBtn(null)}
                >
                <button
                    style={styles.toolbarBtn}
                    onClick={() => {
                    const selected = messages.filter(m =>
                        selectedMessages.includes(m.id)
                    );

                    selected.forEach(toggleFavorite);

                    setSelectedMessages([]);
                    }}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        >
                        <path d="M12 17.3l-5.2 3 1-5.9L3 9.7l6-0.9L12 3l3 5.8 6 0.9-4.8 4.7 1 5.9z" />
                        </svg>
                </button>

                <div
                    style={{
                        ...styles.tooltip,
                        opacity: hoveredBtn === "fav" ? 1 : 0,
                        transform:
                        hoveredBtn === "fav"
                            ? "translateX(-50%) translateY(4px)"
                            : "translateX(-50%) translateY(0px)"
                    }}
                    >
                    В избранное
                    </div>
                </div>

    </div>
  </div>
)}

    <ChatHeader chat={chat} />

    {/* 🔥 ОБЩИЙ КОНТЕЙНЕР (фикс layout) */}
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0, // 💣 ключ
      }}
    >
      {/* MESSAGES */}
            <div
            style={styles.messages}
            onClick={() => {
                if (selectedMessages.length > 0) {
                setSelectedMessages([]);
                }
            }}
            >

                
       {messages.map((m, i) => {
  const currentDate = getDateLabel(m.createdAt);

  const prev = messages[i - 1];
  const prevDate = prev ? getDateLabel(prev.createdAt) : null;

  const showDate = currentDate !== prevDate;

  

  return (
    <div
  key={animateOnLoad ? `${m.id}-anim` : m.id}
  style={
    animateOnLoad
      ? {
          ...styles.messageAppear,
          animationDelay: `${i * 0.04}s`, // 💥 каскад
          opacity: 0,
        }
      : i >= prevCount.current - 1
      ? {
          ...styles.messageAppear, // новые сообщения
        }
      : {}
  }
>
      
      {/* 📅 ДАТА */}
      {showDate && (
        <div
          style={{
            textAlign: "center",
            margin: "16px auto",
            padding: "6px 12px",
            fontSize: 11,

            borderRadius: 12,

            background: "linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.02))",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",

            border: "1px solid rgba(255,255,255,0.08)",

            color: "rgba(255,255,255,0.85)",

            width: "fit-content",

            boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
            }}
        >
          {currentDate}
        </div>
      )}

      {/* 💬 СООБЩЕНИЕ */}
      <MessageBubble
          message={m}
  userData={usersMap[m.sender]}
        isOwn={m.sender === user}
        isHighlighted={highlightId === m.id}
        getTime={getTime}
        onReply={() =>
          setReply({
            id: m.id,
            text: m.text || "📷 Фото",
            sender: m.sender
          })
        }
        isSelected={selectedMessages.includes(m.id)}
        isSelectionMode={isSelectionMode}
        onSelect={() => toggleSelect(m.id)}
          isGroup={chat?.isGroup}
      />
    </div>
  );
})}

        <div ref={bottomRef} />
      </div>

      {/* typing (теперь не ломает layout) */}
      {typing && typing.user !== user && (
  <div style={styles.typing}>
    {chat.user.name}{" "}
    {typing.type === "text" && "печатает..."}
    {typing.type === "deleting" && "удаляет..."}
    {typing.type === "image" && "отправляет фото..."}
    {typing.type === "voice" && "записывает голосовое..."}
  </div>
)}
    </div>

{diceFlash && (
  <div
    style={{
      position: "absolute",
      inset: 0,
      background: "white",
      opacity: 0.12,
      pointerEvents: "none",
      zIndex: 25,
      animation: "flash 0.4s ease",
    }}
  />
)}

{rollingDice && (
  <>
    {/* 🎲 кубик */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        zIndex: 20,
      }}
    >
      <div
        style={{
          width: 90,
          height: 90,
          borderRadius: 20,
          background: "rgba(20,20,20,0.7)",
          backdropFilter: "blur(20px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transform: `
            translate(${dicePos.x}px, ${dicePos.y}px)
            scale(${dicePos.scale})
            rotate(720deg)
          `,
          transition: "all 0.8s cubic-bezier(.2,1.4,.4,1)",
        }}
      >
        <div style={{ transform: "scale(2)" }}>
          {renderBigDice(
            rollingDice.dice,
            rollingDice.value,
            rollingDice.dice === 20 && rollingDice.value === 20
          )}
        </div>
      </div>

      {/* тень */}
      <div
        style={{
          position: "absolute",
          bottom: "calc(50% - 5px)",
          width: 70,
          height: 14,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.5)",
          filter: "blur(10px)",
          transform: `
            translateY(${dicePos.y * 0.6}px)
            scale(${dicePos.scale})
          `,
          transition: "all 0.8s cubic-bezier(.2,1.4,.4,1)",
        }}
      />
    </div>

    {/* ✨ particles */}
    {diceParticles.map((p) => {
      const x = Math.cos(p.angle) * p.distance;
      const y = Math.sin(p.angle) * p.distance;

      return (
        <div
          key={p.id}
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            width: p.size,
            height: p.size,
            borderRadius: "50%",
            background:
              p.type === "crit"
                ? "white"
                : "rgba(255,80,80,0.9)",
            transform: `translate(${x}px, ${y}px)`,
            opacity: 0,
            animation: `particle ${p.duration}ms ease-out forwards`,
            pointerEvents: "none",
            zIndex: 30,
          }}
        />
      );
    })}
  </>
)}

    <MessageInput
  onSend={sendMessage}
  onFile={sendImage}
  reply={reply}
  setReply={setReply}
  chatId={chatId}   // ✅ ДОБАВИЛИ
  user={user}       // ✅ ДОБАВИЛИ
/>
  </div>
);
}